import {
  BoldTextLeaf,
  CodeTextLeaf,
  ItalicTextLeaf,
  StrikethroughTextLeaf,
  UnderlineTextLeaf,
} from '@typedream/components';
import { onKeyDownToggleMark } from '@udecode/plate-core';
import { createTPluginFactory } from '../../plate';
import {
  KEY_BASIC_MARKS,
  KEY_COLLECTION_CONNECT_DATA,
  MARK_BOLD,
  MARK_CODE,
  MARK_ITALIC,
  MARK_STRIKETHROUGH,
  MARK_UNDERLINE,
} from '../../pluginKeys';
import CollectionDataElement from '../collection/components/CollectionDataElement';

const createBoldTextPlugin = createTPluginFactory({
  key: MARK_BOLD,
  isLeaf: true,
  component: BoldTextLeaf,
  handlers: {
    onKeyDown: onKeyDownToggleMark,
  },
  options: {
    hotkey: 'mod+b',
  },
});

const createUnderlineTextPlugin = createTPluginFactory({
  key: MARK_UNDERLINE,
  isLeaf: true,
  component: UnderlineTextLeaf,
  handlers: {
    onKeyDown: onKeyDownToggleMark,
  },
  options: {
    hotkey: 'mod+u',
  },
});

const createItalicTextPlugin = createTPluginFactory({
  key: MARK_ITALIC,
  isLeaf: true,
  component: ItalicTextLeaf,
  handlers: {
    onKeyDown: onKeyDownToggleMark,
  },
  options: {
    hotkey: 'mod+i',
  },
});

const createStrikethroughTextPlugin = createTPluginFactory({
  key: MARK_STRIKETHROUGH,
  isLeaf: true,
  component: StrikethroughTextLeaf,
  handlers: {
    onKeyDown: onKeyDownToggleMark,
  },
  options: {
    hotkey: 'mod+shift+x',
  },
});

const createCodeTextPlugin = createTPluginFactory({
  key: MARK_CODE,
  isLeaf: true,
  component: CodeTextLeaf,
  handlers: {
    onKeyDown: onKeyDownToggleMark,
  },
  options: {
    hotkey: 'mod+e',
  },
});

const createCollectionConnectDataTextPlugin = createTPluginFactory({
  key: KEY_COLLECTION_CONNECT_DATA,
  isLeaf: true,
  component: CollectionDataElement,
});

export const createBasicMarksPlugin = createTPluginFactory({
  key: KEY_BASIC_MARKS,
  plugins: [
    createBoldTextPlugin(),
    createCodeTextPlugin(),
    createItalicTextPlugin(),
    createStrikethroughTextPlugin(),
    createUnderlineTextPlugin(),
    createCollectionConnectDataTextPlugin(),
  ],
});
